export { default } from "./FlexDisplay";
